<div class="dialog-box">
  <div class="dialog-box__content">
    <div class="title_dialog">
      <img src="../../../assets/svg/send_cert.svg">
      <span>{{ 'SEND_WITH_CERT.TITLE' | translate }}</span>
      <button mat-icon-button mat-dialog-close tabindex="-1">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
    <div class="send-with-cert">
      <div class="send-with-cert__stage form-content flex_box">
        <div class="left_wrap">
          <label class="file-upload-button">
            <input type="file" accept=".pfx" (change)="onCertSelect()" #certField>
            <div class="label_text">
              {{ 'SEND_WITH_CERT.LABEL_UPLOAD' | translate }}
            </div>
            @if (!sending) {
              <div class="btn_upload">
                {{ 'SEND_WITH_CERT.UPLOAD' | translate }}
              </div>
            }
            @if (sending) {
              <button class="btn_upload" disabled>
                {{ 'SEND_WITH_CERT.UPLOAD' | translate }}
              </button>
            }
          </label>

          @if (cert) {
            <div class="send-with-cert__cert">
              <span class="send-with-cert__cert-title">{{ 'SEND_WITH_CERT.CERT' | translate }}:</span>
              <span class="send-with-cert__cert-name">{{ cert.name }}</span>
            </div>
          }
        </div>

        <div class="right_wrap">
          <app-form-input
            [label]="'PIN:'"
            [(model)]="pin"
            [inputType]="'password'"
            [placeholder]="'SEND_WITH_CERT.ENTER_PIN'"
            [certInput]="true"
          ></app-form-input>
        </div>
      </div>
      @if (errors) {
        @if (errors[0]) {
          <div class="send-with-cert__stage">
            <div class="alert-box">{{ errors[0] }}</div>
          </div>
        }
      }
      @if (info) {
        <div class="send-with-cert__stage">
          <div class="alert-box alert-box--info">{{ info }}</div>
        </div>
      }

      <div class="dialog-box__form-buttons">
        <button class="btn btn--secondary btn--small"  mat-dialog-close>{{ 'COMMON.CANCEL' | translate }}</button>
        <button class="btn btn--primary btn--longer" (click)="onSubmit()" [disabled]="sending">
          {{ 'COMMON.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
